export function createListener() {
    throw new Error('WebSocket Servers can not be created in the browser!');
}
//# sourceMappingURL=listener.browser.js.map